import styled from "styled-components";

const LoadFileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
`;

export default LoadFileContainer;
